'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toggleItem = function toggleItem(event, target) {
  var self = target;
  var footerMenus = document.querySelectorAll('[data-footer-menu]');
  footerMenus.forEach(function (menu) {
    menu != self && menu.classList.remove('open');
    menu == self && menu.classList.toggle('open');
  });
};

var bindActions = function bindActions() {
  var footerMenus = document.querySelectorAll('[data-footer-menu]');
  footerMenus.forEach(function (menu) {
    menu.addEventListener('click', function (event) {
      toggleItem(event, menu);
    });
  });
};

exports.default = {
  bindActions: bindActions
};